import { Link } from 'react-router-dom'
import SeoHead from '../components/SeoHead'
import { isPageSeoEnabled } from '../config/siteConfig'
import './Legal.css'

const Terms = () => {
  const seoEnabled = isPageSeoEnabled('terms')
  
  return (
    <div className="legal-page">
      <SeoHead
        title="Terms of Use | SIBR Lifescience"
        description="Terms of use for SIBR Lifescience website. Read our terms and conditions for using this website."
        canonical="/terms"
        seoEnabled={seoEnabled}
      />
      
      <section className="legal-hero">
        <div className="container">
          <h1>Terms of Use</h1>
          <p>Please read these terms carefully before using our website.</p>
        </div>
      </section>

      <section className="legal-content section">
        <div className="container">
          <div className="legal-wrapper">
            <article className="legal-article">
              <h2>Acceptance of Terms</h2>
              <p>
                By accessing and using the SIBR Lifescience website ("Website"), you accept and 
                agree to be bound by these Terms of Use ("Terms") and our <Link to="/privacy">Privacy Policy</Link>. 
                If you do not agree to these Terms, please do not use this Website.
              </p>

              <h2>Use of Website</h2>
              <p>You agree to use this Website only for lawful purposes and in a manner that:</p>
              <ul>
                <li>Does not infringe the rights of any third party</li>
                <li>Does not restrict or inhibit anyone else's use of the Website</li>
                <li>Does not violate any applicable laws or regulations</li>
                <li>Does not involve the transmission of harmful content or malware</li>
                <li>Does not attempt to gain unauthorized access to any part of the Website</li>
              </ul>

              <h2>Intellectual Property</h2>
              <p>
                All content on this Website, including but not limited to text, graphics, logos, 
                images, and software, is the property of SIBR Life Sciences Private Limited or 
                its content suppliers and is protected by intellectual property laws.
              </p>
              <p>You may not:</p>
              <ul>
                <li>Reproduce, distribute, or modify any content without written permission</li>
                <li>Use our trademarks or logos without authorization</li>
                <li>Create derivative works based on our content</li>
                <li>Use automated tools to extract or scrape content from our Website</li>
              </ul>

              <h2>Product Information</h2>
              <p>
                Information about our products on this Website is provided for general 
                informational purposes only. Please refer to our <Link to="/disclaimer">Medical Disclaimer</Link> for 
                important information about the limitations of product information provided.
              </p>
              <p>
                We reserve the right to modify product information, pricing, and availability 
                without prior notice. Product images are for illustrative purposes only and may 
                not exactly represent the actual product.
              </p>

              <h2>Third-Party Links</h2>
              <p>
                This Website may contain links to third-party websites, including e-commerce 
                platforms where our products are sold (such as 1mg). These links are provided 
                for convenience only.
              </p>
              <ul>
                <li>We do not control or endorse these third-party websites</li>
                <li>We are not responsible for their content, policies, or practices</li>
                <li>Your use of third-party websites is at your own risk</li>
                <li>Transactions on third-party platforms are governed by their terms</li>
              </ul>

              <h2>Disclaimer of Warranties</h2>
              <p>
                This Website is provided "AS IS" and "AS AVAILABLE" without warranties of any 
                kind, either express or implied, including but not limited to:
              </p>
              <ul>
                <li>Warranties of merchantability or fitness for a particular purpose</li>
                <li>Warranties that the Website will be uninterrupted or error-free</li>
                <li>Warranties regarding the accuracy or completeness of content</li>
                <li>Warranties against viruses or other harmful components</li>
              </ul>

              <h2>Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, SIBR Life Sciences Private Limited 
                shall not be liable for any direct, indirect, incidental, special, consequential, 
                or punitive damages arising from:
              </p>
              <ul>
                <li>Your use of or inability to use this Website</li>
                <li>Any errors or omissions in the content</li>
                <li>Unauthorized access to or alteration of your data</li>
                <li>Any third-party conduct or content on the Website</li>
              </ul>

              <h2>Indemnification</h2>
              <p>
                You agree to indemnify and hold harmless SIBR Life Sciences Private Limited, its 
                officers, directors, employees, and agents from any claims, damages, losses, or 
                expenses arising from your violation of these Terms or your use of the Website.
              </p>

              <h2>Governing Law</h2>
              <p>
                These Terms shall be governed by and construed in accordance with the laws of 
                India. Any disputes arising from these Terms or your use of the Website shall 
                be subject to the exclusive jurisdiction of the courts in Himachal Pradesh, India.
              </p>

              <h2>Modifications</h2>
              <p>
                We reserve the right to modify these Terms at any time. Changes will be effective 
                immediately upon posting to the Website. Your continued use of the Website after 
                any modifications constitutes your acceptance of the revised Terms.
              </p>

              <h2>Severability</h2>
              <p>
                If any provision of these Terms is found to be invalid or unenforceable, the 
                remaining provisions shall continue in full force and effect.
              </p>

              <h2>Contact Us</h2>
              <p>
                If you have questions about these Terms of Use, please contact us:
              </p>
              <address>
                <strong>SIBR Life Sciences Private Limited</strong><br />
                Email: <a href="mailto:legal@sibrlifescience.com">legal@sibrlifescience.com</a><br />
                <Link to="/contact">Contact Page</Link>
              </address>

              <p className="last-updated">
                <em>Last updated: December 2024</em>
              </p>
            </article>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Terms

